import {Injectable} from '@angular/core';


interface DefaultPluginOptions {
  chartType?: string;
  textColor?: string;
  textSize?: number;
}

@Injectable()
export class ChartDataLabelsPlugin {
  constructor() {
  }


  initialize({
               chartType = 'pie',
               textColor = 'black',
               textSize = 14
             }: DefaultPluginOptions): any {
    return {
      afterDatasetsDraw: (chartInstance) => {
        const ctx = chartInstance.chart.ctx;
        chartInstance.data.datasets.forEach(function (dataset, i) {
          const meta = chartInstance.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach(function (element, index) {
              ctx.fillStyle = textColor;
              const fontSize = textSize;
              const fontStyle = 'normal';
              const fontFamily = 'FuturaBold, "Futura", sans-serif';
              // @ts-ignore
              ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
              const dataString = dataset.data[index].toString();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const position = element.tooltipPosition();
              let paddingY = 0;
              if (chartType === 'bar') {
                paddingY = -4.5;
              }
              ctx.fillText(dataString, position.x, position.y + paddingY);
            });
          }
        });
      }
    };
  }
}
